import {UsersListToolbar} from './UserListToolbar'



const UsersListHeader = () => {

  return (
    <div className='card-header border-0 pt-6'>
      {/*<UsersListSearchComponent />*/}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
          <UsersListToolbar />
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {UsersListHeader}
